var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { RMap } from "../../collections";
import { makeImmutable } from "../../core";
import { LocalizationProvider } from "../../locale";
import { MenuSectionItemId, } from "../../ordering";
import { perRestaurant } from "../../di";
import { TranslatedParser } from "../../parsing";
import { PMenuSectionItem, PMenuSectionItemCreatorContent, PMenuSectionItemSingleProductContent, } from "../PMenuSectionItem";
import { PProductInstanceVariantFactory } from "../PProductInstanceVariantFactory";
import { VariantInstanceFactory } from "../VariantInstanceFactory";
import { LabelsService } from "../../labels";
let PMenuSectionItemParser = class PMenuSectionItemParser {
    constructor(localizationProvider, translatedParser, labelsService, pProductInstanceVariantFactory, variantInstanceFactory) {
        this.localizationProvider = localizationProvider;
        this.translatedParser = translatedParser;
        this.labelsService = labelsService;
        this.pProductInstanceVariantFactory = pProductInstanceVariantFactory;
        this.variantInstanceFactory = variantInstanceFactory;
        makeImmutable(this);
    }
    variantParameterChoiceName(customParameterTypes, variant) {
        const parameterChoices = variant.customParameterChoices.choices.entries.map(([customParameterType, customParameterChoice]) => customParameterTypes
            .get(customParameterType.id)
            .choices.get(customParameterChoice).name);
        return parameterChoices.raw.join(" / ");
    }
    variant(customParameterTypes, domainVariant) {
        const instance = this.variantInstanceFactory.create(domainVariant);
        if (instance === null) {
            return null;
        }
        return this.pProductInstanceVariantFactory.create({
            instance,
            variantParameterChoiceName: this.variantParameterChoiceName(customParameterTypes, domainVariant),
        });
    }
    parseSingleProductContent(params) {
        var _a, _b, _c, _d;
        const { domainSection, productType } = params;
        const productVariants = domainSection.variants.get(productType.id);
        const productColumns = domainSection.columns.find(productType.id);
        return new PMenuSectionItemSingleProductContent({
            id: productType.id,
            name: productType.name,
            description: productType.description,
            variants: productVariants.mapOptional((domainVariant) => this.variant(params.customParameterTypes, domainVariant)).raw,
            columns: productColumns === null
                ? RMap.empty()
                : productColumns.mapOptional((domainVariant) => this.variant(params.customParameterTypes, domainVariant)),
            availabilitySchedule: productType.availabilitySchedule,
            localizationProvider: this.localizationProvider,
            photoUrn: (_b = (_a = productType.photo) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : null,
            photoAlt: (_d = (_c = productType.photo) === null || _c === void 0 ? void 0 : _c.alt.value) !== null && _d !== void 0 ? _d : null,
            tags: productType.tags,
            allergens: productType.allergens,
            freeModifierItemsCount: productType.freeModifierItemsCount,
            baseIngredients: productType.baseIngredients,
            labelsService: this.labelsService,
        });
    }
    parseCreatorContent(customParameterTypes, creatorVariant, creatorData) {
        var _a, _b;
        const variant = this.variant(customParameterTypes, creatorVariant);
        if (variant === null) {
            return null;
        }
        return new PMenuSectionItemCreatorContent({
            variant,
            name: this.translatedParser.parse(creatorData.creatorName),
            description: this.translatedParser.parse(creatorData.creatorDescription),
            photoUrn: (_b = (_a = creatorData.creatorPhoto) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : null,
            photoAlt: creatorData.creatorPhoto !== null
                ? this.translatedParser.parse(creatorData.creatorPhoto.alt)
                : null,
        });
    }
    parseContent(params) {
        switch (params.item.tag) {
            case "SingleProduct": {
                const productType = params.productTypes.rawFind(params.item.itemProduct);
                if (productType === null) {
                    return null;
                }
                return this.parseSingleProductContent({
                    customParameterTypes: params.customParameterTypes,
                    domainSection: params.domainSection,
                    productType,
                });
            }
            case "ProductCreator": {
                const creatorVariant = params.domainSection.creators.rawFind(params.id);
                if (creatorVariant === null) {
                    return null;
                }
                return this.parseCreatorContent(params.customParameterTypes, creatorVariant, params.item);
            }
            default:
                return null;
        }
    }
    parse(params) {
        const content = this.parseContent(params);
        if (content === null) {
            return null;
        }
        return new PMenuSectionItem({
            id: new MenuSectionItemId(params.id),
            content,
        });
    }
};
PMenuSectionItemParser = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _a : Object, typeof (_b = typeof TranslatedParser !== "undefined" && TranslatedParser) === "function" ? _b : Object, typeof (_c = typeof LabelsService !== "undefined" && LabelsService) === "function" ? _c : Object, typeof (_d = typeof PProductInstanceVariantFactory !== "undefined" && PProductInstanceVariantFactory) === "function" ? _d : Object, typeof (_e = typeof VariantInstanceFactory !== "undefined" && VariantInstanceFactory) === "function" ? _e : Object])
], PMenuSectionItemParser);
export { PMenuSectionItemParser };
